var map = {
	"./ar.json": 6556,
	"./en.json": 5188,
	"./fr.json": 2303,
	"./ge.json": 8739,
	"./hi.json": 1840,
	"./ja.json": 9730,
	"./ko.json": 9057,
	"./po.json": 5126,
	"./ru.json": 7526,
	"./sp.json": 2296,
	"./zh-CN.json": 1245,
	"./zh-TW.json": 5617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;